export default "__VITE_ASSET__DWJU3Bsh__"